/*
 * @Descripttion:
 * @version:
 * @Author: wlk
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: wlk
 * @LastEditTime: 2024-04-23 11:45:28
 */
import { defineStore } from 'pinia'
import {lang} from '@/utils/index.ts'

const lang = navigator.language.slice(0, 2)
export const useSettingStore = defineStore('sysSetting', {
  state: () => ({
    collapsed: false,
    openKeys: [] as number[],
    selectedKeys: [] as number[],
    // locale: (LangType[lang] ? lang : 'en') as keyof typeof LangType,
    locale: 'cn',
    /**翻译数据json */
    langJson: {} as Record<'pt' | 'en', any>,
    station: {
      printer: '',
      template: 1,
      language: 'CN',
      isShowLogo: true
    } as Record<string, any>,
    lodopStatus: false as boolean,
    pendingCountData: [] as string[],
    scanDataList: [] as any,
  }),
  getters: {
    getCollapsed: (state) => state.collapsed,
    getOpenKeys: (state) => state.openKeys,
    getSelectedKeys: (state) => state.selectedKeys,
    getStation: (state) => state.station,
    getPrinter: (state) => state.station.printer,
    getScanDataList: (state) => state.scanDataList,
  },
  actions: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setOpenkeys(keys: number[]) {
      if (this.openKeys.length) return
      this.openKeys = keys
    },
    setSelectedKeys(keys: number[]) {
      this.selectedKeys = keys
    },
    setPrinter(printer: string) {
      this.station.printer = printer
    },
    setScanDataList(data: any) {
      this.scanDataList = data
    },
    setStation(printerInfo: any) {
      this.station = printerInfo
    }
  },
  persist: {
    storage: localStorage,
    paths: ['collapsed', 'locale', 'langJson', 'station', 'scanDataList']
  }
})
